<script setup>
defineProps({
  actions: {
    type: Array,
    required: true,
    default: () => [],
  },
});

defineEmits(["action"]);
</script>

<template>
  <div class="quick-actions">
    <div
      v-for="(action, index) in actions"
      :key="`${action.subtitle}-${index}`"
      class="card"
      @click="action.action && $emit('action', action)"
    >
      <div v-if="action.icon" class="icon">
        <svg-icon
          :name="action.icon"
          class="w-6 h-6 text-red-600"
          style="fill: none"
        />
      </div>
      <div class="text">
        <div class="title">
          <p
            v-for="(line, lineIndex) in action.titleLines"
            :key="`${line}-${lineIndex}`"
            class="title-line"
          >
            {{ line }}
          </p>
        </div>
        <div class="subtitle">{{ action.subtitle }}</div>
      </div>
    </div>
  </div>
</template>

<style scoped lang="scss">
.quick-actions {
  @apply w-full flex gap-2.5;
  max-width: 700px;

  .card {
    @apply flex-1 px-5 py-4 bg-card  outline outline-1 outline-offset-[-1px];
    @apply outline-border flex flex-col gap-3 overflow-hidden cursor-pointer;
    border-radius: var(--radius);
  }

  .icon {
    @apply relative overflow-hidden;
  }

  .text {
    @apply flex flex-col gap-2;
  }

  .title {
    @apply text-sm font-bold text-foreground w-full;
  }

  .title-line {
    @apply block leading-5;
  }

  .subtitle {
    @apply text-xs font-normal text-muted-foreground leading-4;
  }
}

@media (max-width: 900px) {
  .quick-actions {
    @apply w-full;
  }
}
</style>
